import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled.div`
    background-color: ${colorsPalettes.sky[100]};
    width: 58%;
    border-radius: 8px;
    padding: 24px;
`;

export const BlueTag = styled.div`
    position: absolute;
    height: 6px;
    width: 145px;
    top: 96px;
    left: 377px;
    border-radius: 0 8px 0 0;
    background: ${colorsPalettes.blue["400"]};
`;

export const PackageTagText = styled.div`
    ${setFontVariant("dataTable1", colorsPalettes.carbon[0])}
`;

export const PackageTag = styled(CenteredFlexRow)`
    position: absolute;
    top: 72px;
    left: 233px;
    width: 144px;
    height: 30px;
    border-radius: 8px 8px 0 0;
    background: ${colorsPalettes.carbon["250"]};
`;

export const Title = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 42px;
    ${setFontVariant("subsectionTitle", colorsPalettes.carbon["500"])};
`;

export const StyledTable = styled.table`
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
`;

export const StyledRow = styled.tr`
    background-color: ${colorsPalettes.carbon[0]};
`;

export const StyledCell = styled.td<{ background?: string }>`
    width: ${(props) => props.width || "auto"};
    background: ${({ background }) => background || null};
    padding: 10px 16px;
    border-top: 1px solid ${colorsPalettes.carbon["50"]};
    border-left: 1px solid ${colorsPalettes.carbon["50"]};
    border-bottom: none;
    tbody tr:first-child &:first-child {
        border-radius: 8px 0 0 0;
        border-right: none;
    }
    &:last-child {
        border-right: 1px solid ${colorsPalettes.carbon["50"]};
    }
    tbody tr:last-child &:first-child {
        border-radius: 0 0 0 8px;
        border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
    }
    tbody tr:last-child &:last-child {
        border-radius: 0 0 8px 0;
        border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
    }
`;

export const StyledHeaderCell = styled.th<{ width: string; withBorder: boolean; background?: string }>`
    width: ${({ width }) => width || "auto"};
    border: ${({ withBorder }) => (withBorder ? "1px solid #E6E9EC" : null)};
    border-bottom: none;
    background: ${({ background }) => background || null};
    padding: 8px;
    text-align: left;
`;

export const HeaderText = styled(CenteredFlexRow)`
    ${setFontVariant("button", colorsPalettes.carbon["400"])};
`;

export const FirstColumnText = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const ItemText = styled.div`
    ${setFontVariant("dataTable2", colorsPalettes.carbon["400"])};
`;

export const ItemData = styled(CenteredFlexRow)`
    ${setFontVariant("dataTable2", colorsPalettes.carbon["500"])};
`;

const IconButtonStyled = styled(IconButton)`
    position: absolute;
    top: 28px;
    left: 28px;
`;

export const BackButtonStyled = styled(IconButton)`
    position: absolute;
    top: 16px;
    left: 16px;
    .SWReactIcons {
        svg {
            path {
                fill: ${colorsPalettes.carbon[400]};
            }
        }
    }
`;

export const BackButtonText = styled.div`
    ${setFontVariant("sectionTitle", colorsPalettes.carbon["400"])};
    font-weight: 500;
`;
